import Vue from 'vue';
import Vuex from 'vuex';
import { mutationTypes } from './types';
import modules from './modules';

Vue.use(Vuex);

export default new Vuex.Store({
  strict: true,
  modules,
  state: {
    processes: 0,
    panelOpen: false,
    panelManuallyToggled: false,
    error: null,
  },
  getters: {
    canAutoTogglePanel: state => !state.panelManuallyToggled,
  },
  actions: {},
  mutations: {
    [mutationTypes.global.addProcess](state) {
      state.processes += 1;
    },

    [mutationTypes.global.removeProcess](state) {
      state.processes = Math.max(state.processes - 1, 0);
    },

    [mutationTypes.global.setPanelOpen](state, payload) {
      state.panelOpen = payload;
    },

    [mutationTypes.global.togglePanelOpen](state) {
      state.panelOpen = !state.panelOpen;
    },

    [mutationTypes.global.setPanelManuallyToggled](state) {
      state.panelManuallyToggled = true;
    },

    [mutationTypes.global.setError](state, payload) {
      state.error = payload;
    },
  },
});



// WEBPACK FOOTER //
// ./src/store/index.js